import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import ImageLoader from "../components/ImageLoader";
import CustomButton from "../components/CustomButton";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";
import { useLocation } from "react-router-dom";

const ServiceDetail = ({ data }) => {
  const location = useLocation();

  const handleWhatsApp = (title) => {
    trackEvent(`receta_medica_whatsapp`, {
      page_path: location.pathname,
      page_url: window.location.href,
      section: "receta_medica_WhatsApp",
      cta_name: "enviar_mensaje",
      value: 1,
    });

    openWhatsApp(
      "5959570961",
      `Hola Centro Médico MEDAM 👋, me podrias ayudar con mi receta médica.`,
      true,
    );
  };
  return (
    <Grid container p={{ xs: 1, md: 5 }}>
      <Grid size={styles.grid15} />
      <Grid size={data.image ? styles.grid9 : styles.grid6}>
        <Box sx={styles.container}>
          <Box sx={styles.circle(data.circleColor || data.color)} />
          <Grid container alignItems="center">
            <Grid item size={data.image ? styles.grid7 : styles.grid12}>
              <Box sx={styles.leftColumn}>
                <Typography sx={styles.tag(data?.color)}>{data.tag}</Typography>
                <Typography sx={styles.title}>{data.title}</Typography>
                <Box sx={styles.line(data?.color)} />
                {data.paragraphs?.map((paragraph, index) => (
                  <Typography key={index} sx={styles.paragraph}>
                    {paragraph}
                  </Typography>
                ))}
                {data.highlight && (
                  <Box sx={styles.highlight(data.color, data.bgColor)}>
                    <Typography sx={styles.highlightText}>
                      {data.highlight}
                    </Typography>
                  </Box>
                )}
                {data.footer && (
                  <Typography sx={styles.footer}>{data.footer}</Typography>
                )}
              </Box>
            </Grid>
            {data.image && (
              <Grid item size={styles.grid5}>
                <Box sx={styles.imageContainer}>
                  <ImageLoader
                    src={data.image}
                    alt={data.title}
                    width="100%"
                    height="100%"
                    borderRadius={2}
                    style={styles.objet}
                  />
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </Grid>
      {data.image === null && (
        <Grid size={styles.grid5} sx={styles.Align}>
          <Box sx={styles.BoxCard}>
            <Typography sx={styles.TextTitulo}>
              ¿Conoces los medicamentos
              <br />
              que necesitas?
            </Typography>
            <CustomButton
              type="submit"
              variant="contained"
              backgroundColor="#D9784A"
              colorTexto="#FFFFFF"
              width="100%"
              height={45}
              borderRadius={25}
              onClick={handleWhatsApp}
              style={styles.Botto}
            >
              Cotiza tu receta médica
            </CustomButton>
          </Box>
        </Grid>
      )}
      <Grid size={styles.grid6} />
    </Grid>
  );
};

export default ServiceDetail;

const styles = {
  container: {
    position: "relative",
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0px 18px 45px rgba(0,0,0,.08)",
    px: {
      xs: 2,
      sm: 5,
      md: 2,
      lg: 3,
    },
    py: {
      xs: 3,
      md: 2,
    },
    margin: "auto",
  },
  circle: (color) => ({
    position: "absolute",
    width: 180,
    height: 180,
    background: color,
    borderRadius: "50%",
    top: -90,
    left: -90,
    zIndex: 0,
  }),
  leftColumn: {
    position: "relative",
    zIndex: 5,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%",
  },
  tag: (color) => ({
    color: color,
    fontWeight: 700,
    letterSpacing: "2px",
    textTransform: "uppercase",
    fontSize: {
      xs: 13,
      md: 10,
    },
    mb: 1,
  }),
  title: {
    color: "#000",
    fontWeight: 800,
    lineHeight: 1,
    fontSize: {
      xs: 42,
      sm: 52,
      md: 30,
      lg: 25,
    },
    mb: 2,
  },
  line: (color) => ({
    width: 72,
    height: 6,
    borderRadius: 50,
    background: color,
    mb: 2,
  }),
  paragraph: {
    color: "#000",
    fontWeight: 400,
    fontSize: {
      xs: 15,
      md: 15,
    },
    lineHeight: 1.5,
    mb: 1,
  },
  footer: {
    color: "#000",
    fontWeight: 700,
    fontSize: {
      xs: 15,
      md: 15,
    },
    lineHeight: 1.6,
    mt: 2,
  },
  highlight: (color, bgColor) => ({
    background: bgColor,
    borderLeft: `5px solid ${color}`,
    borderRadius: "0px 10px 10px 0px",
    p: 1,
    mr: 1,
    boxShadow: "0 10px 20px rgba(0,0,0,.03)",
  }),
  highlightText: {
    color: "#000",
    fontSize: {
      xs: 13,
      md: 13,
    },
    lineHeight: 1.7,
  },
  imageContainer: {
    width: "100%",
    height: {
      xs: 180,
      sm: 300,
      md: 300,
      lg: 400,
    },
    borderRadius: "12px",
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
  },
  objet: {
    objectFit: "cover",
  },
  Align: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
  },
  BoxCard: {
    background: "#F0C9B7",
    width: "80%",
    borderRadius: "30px",
    py: { xs: 3, sm: 5, md: 2, lg: 7 },
    mt: { xs: 3, sm: 0, md: 0, lg: 0 },
    transition: ".35s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
    "&:hover": {
      transform: "translateY(-6px)",
    },
  },
  TextTitulo: {
    color: "#BA5322",
    fontWeight: 800,
    lineHeight: 1,
    fontSize: { xs: 18, sm: 52, md: 30, lg: 25 },
    mb: 4,
    textAlign: "center",
  },
  Botto: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 15,
    fontWeight: 700,
    transition: ".3s",
    "&:hover": {
      transform: "translateY(-2px)",
    },
  },
  grid15: { xs: 0.25, sm: 1.5, md: 1.5, lg: 1.5 },
  grid9: { xs: 11.5, sm: 9, md: 9, lg: 9 },
  grid7: { xs: 12, sm: 7, md: 7, lg: 7 },
  grid6: { xs: 12, sm: 5, md: 5, lg: 5 },
  grid12: { xs: 12, sm: 12, md: 12, lg: 12 },
  grid5: { xs: 12, sm: 5, md: 5, lg: 5 },
};
